import BundleReturn from './content/BundleReturn';
import bundleStore from '../../store/bundleStore';
import React from 'react';
import Confirm from "./content/Confirm";


const ConfirmInfo = ({ setPage,
                         reValid,
                         setReValid,
                         read,
                         setRead,
                         read2,
                         setRead2,
                         setSms,
    sms
}) => {

    if (sessionStorage.getItem('bundlePayment') || bundleStore.result) return <BundleReturn />;

    return (
        <Confirm setPage={setPage} setReValid={setReValid} setRead={setRead} setRead2={setRead2}>
            <Confirm.Data setSms={setSms} sms={sms}/>
        </Confirm>
    );
};



export default ConfirmInfo;
